type PlatformTypeParamsType = {
    platformType: string;
};

const getPlatformType = (): string => {
    return 'desktop';
};

const getPlatformTypeParams = (): PlatformTypeParamsType => {
    return {
        platformType: getPlatformType(),
    };
};

export { getPlatformType, getPlatformTypeParams };
